import { useEffect, useState } from 'react';
import { PaginatedResponseData } from '../../services/api/client';
import { StoreDetails } from '../../types/store';
import { loadStores } from '../../services/api/StoreService';
import { Button, Input, Table } from 'antd';
import React from 'react';
import useStore from '../../hooks/context/useStore';
import { useNavigate } from 'react-router';
import { Routes } from '../../routing/Router';
import PaginationHelpers from '../../services/utils/pagination/PaginationHelpers';
import { debounce } from 'lodash';

export default function StoreListPage() {
  const { storeId, loadStoreData, setStoreData, onPreviewStore, setShowSidebar } = useStore();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [data, setData] = useState<PaginatedResponseData<StoreDetails>>(
    PaginationHelpers.initPaginationData(),
  );

  const debounced = debounce(async (page: number) => loadData(page), 500);

  useEffect(() => {
    debounced(1);

    return () => debounced.cancel();
  }, [searchQuery]);

  async function loadData(page: number) {
    setLoading(true);

    loadStores({
      page,
      query: searchQuery,
    })
      .then(({ data: _data }) => setData(_data))
      .catch((error) => console.error('Failed to load stores', { error }))
      .finally(() => setLoading(false));
  }

  const onSelectStore = (store: StoreDetails) => {
    if (store.id === storeId) {
      return setShowSidebar(true);
    }

    setStoreData(store);
    setShowSidebar(true);
    loadStoreData({ id: store.id });
    navigate(`/${Routes.NewOrder.Root}`);
  };

  return (
    <>
      <h1>Restaurants</h1>
      <Input.Search
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="mt-sm"
        placeholder="Search store"
      />
      <Table
        dataSource={data.data}
        loading={loading}
        rowKey="id"
        className="mt-sm overflow-x-auto"
        pagination={{
          current: data.meta.current_page,
          total: data.meta.total,
          pageSize: data.meta.per_page,
          onChange: (page) => loadData(page),
          rootClassName: 'tw-overflow-hidden',
        }}
        columns={[
          {
            key: 'name',
            title: 'Name',
            dataIndex: 'name',
          },
          {
            key: 'phone',
            title: 'Phone',
            dataIndex: ['contacts', 'phone_number'],
          },
          {
            key: 'address',
            title: 'Address',
            dataIndex: ['location', 'formatted_address'],
          },
          {
            key: 'actions',
            title: '',
            render: (item) => (
              <>
                <Button type="link" onClick={() => onPreviewStore(item)}>
                  Show details
                </Button>
                <Button type="link" onClick={() => onSelectStore(item)}>
                  Create order
                </Button>
              </>
            ),
          },
        ]}
      />
    </>
  );
}
